<template>
  <div id="lineChart" style="width: 90%; height: 600px; margin: 0 auto;"></div>
</template>

<script>
import axios from 'axios';
import * as echarts from 'echarts';
import {shallowRef} from "vue";

export default {
  name: 'LineChart',
  data() {
    return {
      myChart: shallowRef(null)
    }
  },
  mounted() {

    let data = [[]];
    const chartDom = document.getElementById('lineChart')
    this.myChart = shallowRef(echarts.init(chartDom))

    const option = {
      tooltip: {
        trigger: 'axis'
      },
      title: {
        left: 'center',
        text: '可转债平均年化收益率'
      },
      toolbox: {
        feature: {
          dataZoom: {
            yAxisIndex: 'none'
          },
          saveAsImage: {}
        }
      },
      xAxis: {
        type: 'time',
        boundaryGap: false
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          formatter: '{value} %'
        }
      },
      dataZoom: [
        {
          type: 'inside',
          start: 80,
          end: 100
        },
        {
          start: 0,
          end: 20
        }
      ],
      series: [
        {
          name: 'Fake Data',
          type: 'line',
          smooth: true,
          symbol: 'none',
          areaStyle: {},
          data: data
        }
      ]
    };
    this.myChart.setOption(option)
    window.addEventListener('resize', () => {
      this.myChart.resize()
    })
    this.fetchChartData()
  },
  methods: {
    async fetchChartData() {
      try {
        const response = await axios.get('https://api.hisproc.com/bond/data.json')
        const {dates, values} = response.data

        var formatted_data = dates.map((date, index) => [new Date(date).getTime(), values[index]]);
        this.myChart.setOption({
          xAxis: {
            type: 'time',
          },
          yAxis: {
            type: 'value'
          },
          series: [{
            name: '收益率',
            type: 'line',
            smooth: true,
            data: formatted_data
          }]
        });
      } catch (error) {
        console.error('获取图表数据失败：', error)
      }
    }
  }
}
</script>

<style scoped>
</style>